import logo from './logo.svg';
import './App.css';
import { Route, Routes, useLocation} from 'react-router-dom';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import Home from './component/Home.tsx';
import About from './component/About.tsx';
import { AnimatePresence } from 'framer-motion';

function App() {
  // const location = useLocation();
  return (
    <div className="App">
      <AnimatePresence mode="wait">
        <Home/>
      </AnimatePresence>
    </div>
  );
}

export default App;